module.exports = __webpack_public_path__ + "static/team5-537debe5c7576e7b1d5c5e8b8a67a86b.jpg";